import { RegionNotFoundError } from '../../api/region-not-found-error';

/** What the private-events list says when it cannot load. */
export function privateEventsErrorMessage(error: unknown): string {
  if (error instanceof RegionNotFoundError) {
    return `${error.message}. Pick a region from the list above.`;
  }
  if (error instanceof Error) return error.message;
  return 'Private events couldn’t be loaded. Try again in a moment.';
}
